export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/zachary-staines-f895922433853f9955da516d50a43b06.jpg";